import { ImageUpload } from '@/components/ImageUpload'
import { Label } from '@/components/ui/label'
import { Camera } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { TransferImageField } from './types'

export function TransferActionImages({ label, imageField, testId }: { label: string; imageField: TransferImageField; testId?: string }) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-1.5">
      <Label className="flex items-center gap-1 text-xs">
        <Camera className="size-3" />
        {label}
      </Label>
      <ImageUpload
        files={imageField.files}
        imageIds={imageField.imageIds}
        onChange={imageField.handleChange}
        onRemoveExisting={imageField.handleRemoveExisting}
        maxImages={4}
        testId={testId}
      />
      {imageField.isUploading ? (
        <p className="text-[11px] text-muted-foreground">
          {t('common.uploadingImages')}
          {imageField.uploadProgress ? ` ${imageField.uploadProgress}%` : '...'}
        </p>
      ) : null}
    </div>
  )
}
